import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import styled from '@xstyled/styled-components';
import { Checkbox, Space } from 'antd';
import { BaseQuestionPreview } from '../base-question';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var AnswerItem = styled(Checkbox)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n  .ant-input-affix-wrapper {\n    border-radius: 4px !important;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ", ";\n  }\n  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {\n    border-color: white !important;\n  }\n"])), styleVariables.colors.blue4);
var AnswerContainer = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var AnswerDescription = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), styleVariables.colors.gray11);
var AnswerGroup = styled(Checkbox.Group)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var AnswerItemLayout = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-item: start;\n  justify-content: space-between;\n"])));
export var MultipleChoicePreview = function MultipleChoicePreview(props) {
  var question = props.question,
      index = props.index,
      disabled = props.disabled,
      active = props.active;
  return /*#__PURE__*/_jsx(BaseQuestionPreview, {
    index: index,
    question: question,
    active: active,
    children: /*#__PURE__*/_jsx(AnswerGroup, {
      disabled: disabled,
      value: question.correctAnswers.map(function (a) {
        return a.answerId;
      }),
      children: /*#__PURE__*/_jsx(AnswerContainer, {
        direction: "vertical",
        size: "middle",
        children: question.answers.map(function (a, index) {
          return /*#__PURE__*/_jsx(AnswerItemLayout, {
            children: /*#__PURE__*/_jsx(AnswerItem, {
              value: a.id.toString(),
              disabled: true,
              children: /*#__PURE__*/_jsx(AnswerDescription, {
                children: a.description
              })
            }, index)
          }, index);
        })
      })
    })
  });
};